module.exports = __webpack_public_path__ + "static/coming-soon-bg-585d650ece56865a6886846ea4ee21b7.jpg";